
























































import { Component, Prop, Vue } from "vue-property-decorator";
import { EditSheetCharacteristics } from "@/components/reports/partials/show/edit/types/edit-measurements-characteristic";
import { parseToNumber, valueOrEmpty } from "@/utils/number";
import { CharacteristicDataType } from "@/models/graphql-global-types";
import CharacteristicTitle from "@/components/reports/partials/show/characteristic-title.vue";
import * as _ from "lodash";
import { InputDirection } from "@/models/input-direction";

@Component({
  components: { CharacteristicTitle }
})
export default class EditMeasurements extends Vue {
  @Prop() public characteristics!: EditSheetCharacteristics[];
  @Prop() public isSaving!: boolean;
  @Prop() public inputDirection!: InputDirection;
  private allowedNumericChars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", ","];
  private lastColWithMultiple = -1;

  public mounted() {
    this.characteristics.forEach(c => {
      if (
        c.dataType === CharacteristicDataType.FLOAT ||
        c.dataType === CharacteristicDataType.ONE_FLOAT_PER_CHARACTERISTIC
      ) {
        c.measurements?.forEach(m => {
          m.value = m.value && _.isString(m.value) ? m.value.replace(",", "") : m.value;
        });
      }
    });
  }

  public onPaste = (event: ClipboardEvent, row: number, col: number) => {
    event.preventDefault();
    const pastedData = event.clipboardData
      ? event.clipboardData
          .getData("text/plain")
          .replace(/(\r\n|\n|\r)/gm, "\n")
          .trim()
      : "";
    const pastedRows = pastedData.split(/\n/);
    pastedRows.forEach((pastedRow, rowIndex) => {
      const pastedCells = pastedRow.split(/\t/);
      pastedCells.forEach((pastedCell, cellIndex) => {
        const currentRow = row + rowIndex;
        const currentCol = col + cellIndex;
        const characteristic = this.characteristics[currentRow]?.measurements?.[currentCol];
        this.updateMeasurements(pastedCell, currentRow, currentCol);
      });
    });
  };

  private updateMeasurements = (value, row, col) => {
    if (row > this.characteristics.length || col >= 10) {
      return;
    }

    if (this.isNumeric(row) && parseToNumber(value)) {
      this.characteristics[row].measurements![col].value = value;
    } else if (this.isOkNok(row) && this.isValueOkNok(value)) {
      this.characteristics[row].measurements![col].value = value.toLowerCase().trim();
    } else if (this.isText(row)) {
      this.characteristics[row].measurements![col].value = value;
    } else if (
      this.characteristics[row] &&
      this.characteristics[row].measurements &&
      this.characteristics[row].measurements![col]
    ) {
      this.characteristics[row].measurements![col].value = null;
    }
  };

  public onKeyDown(input: KeyboardEvent, row, col) {
    if (input.key === "Clear" || input.key === "Tab") {
      input.preventDefault();
    }
    this.onGoToNextFocus(input, row, col);
    return true;
  }

  public onKeyUp(input: KeyboardEvent, row: number, col: number) {
    if (input.key === "," && this.characteristics[row] && this.characteristics[row].measurements?.[col]) {
      const value = this.characteristics[row].measurements?.[col].value?.replace(/,/g, ".") ?? null;
      this.$nextTick(() => (this.characteristics[row].measurements![col].value = value));
    }

    return false;
  }

  public onGoToNextFocus(input: KeyboardEvent, row: number, col: number) {
    if (input.key === "Enter" || input.key === "Tab") {
      input.preventDefault();
      this.focusNext(row, col);
    } else if (this.isNumeric(row)) {
      const value = this.characteristics[row]?.measurements?.[col]?.value ?? "";
      if (
        (/^[a-z]$/i.test(input.key) && !input.ctrlKey && !input.metaKey && !input.altKey) ||
        ((value.includes(".") || value.includes(",")) && (input.key === "," || input.key === "."))
      ) {
        // prevent multiple points or commas and non-numeric
        input.preventDefault();
      }
    }
  }

  private focusNext(currentRow: number, currentCol: number) {
    const [row, col] = this.getNextRowColumn(currentRow, currentCol);

    const identifier = `#input_${row}_${col}`;
    $(identifier).focus();
  }

  private getNextRowColumn(currentRow: number, currentCol: number): [number, number] {
    let nextRow = currentRow;
    let nextCol = currentCol;

    if (this.inputDirection === InputDirection.HORIZONTAL) {
      if (currentCol === 9) {
        // go to new row
        nextRow = this.findNextRow(currentRow);
        nextCol = 0;

        if (nextRow === -1) {
          // bottom right end --> end of table. go to 0/0
          nextRow = 0;
        } else {
          // check type of next cell
          const nextCharacteristic = this.characteristics[nextRow];
          if (nextCharacteristic && nextCharacteristic.dataType) {
            switch (nextCharacteristic.dataType) {
              case CharacteristicDataType.ONE_BOOLEAN_PER_CHARACTERISTIC:
              case CharacteristicDataType.ONE_BOOLEAN_PER_PRODUCT:
              case CharacteristicDataType.ONE_FLOAT_PER_CHARACTERISTIC:
              case CharacteristicDataType.ONE_TEXT_PER_PRODUCT:
              case CharacteristicDataType.BOOLEAN:
                //skip
                nextRow = this.findNextRow(currentRow);
                break;
            }
          }
        }
      } else {
        // check current type of next cell
        const current = this.characteristics[currentRow];
        if (current && current.numberOfColumns === 1) {
          // go to next row
          nextRow = this.findNextRow(currentRow);
          nextRow = nextRow !== -1 ? nextRow : 0;
          nextCol = 0;
        } else {
          nextCol++;
        }
      }
    } else {
      if (currentRow === this.characteristics.length - 1) {
        // end of table, go to next column
        nextRow = 0;
        if (currentCol === 0 && this.lastColWithMultiple === 9) {
          nextCol = 0;
          this.lastColWithMultiple = -1;
        } else if (currentCol !== 9 && this.lastColWithMultiple === -1) {
          nextCol++;
        } else if (this.lastColWithMultiple !== -1) {
          nextCol = this.lastColWithMultiple + 1;
          this.lastColWithMultiple = -1;
        } else {
          nextCol = 0;
        }
      } else {
        nextRow++;
        const nextCharacteristic = this.characteristics[nextRow];
        if (nextCharacteristic && nextCharacteristic.dataType) {
          switch (nextCharacteristic.dataType) {
            case CharacteristicDataType.ONE_BOOLEAN_PER_CHARACTERISTIC:
            case CharacteristicDataType.ONE_BOOLEAN_PER_PRODUCT:
            case CharacteristicDataType.ONE_FLOAT_PER_CHARACTERISTIC:
            case CharacteristicDataType.ONE_TEXT_PER_PRODUCT:
              //skip
              nextCol = 0;
              if (this.lastColWithMultiple === -1) {
                this.lastColWithMultiple = currentCol;
              }
              break;
            default:
              if (this.lastColWithMultiple !== -1) {
                nextCol = this.lastColWithMultiple;
                this.lastColWithMultiple = -1;
              }

              break;
          }
        }
      }
    }

    return [nextRow, nextCol];
  }

  private findNextRow(currentRow: number) {
    for (let i = currentRow + 1; i < this.characteristics.length; i++) {
      if (this.isNumeric(i) || this.isText(i) || this.isOkNok(i)) {
        return i;
      }
    }

    return -1;
  }

  public isOkNok(row: number) {
    const dataType = this.characteristics[row]?.dataType;
    return (
      dataType === CharacteristicDataType.BOOLEAN ||
      dataType === CharacteristicDataType.ONE_BOOLEAN_PER_CHARACTERISTIC ||
      dataType === CharacteristicDataType.ONE_BOOLEAN_PER_PRODUCT
    );
  }

  public isRowBoolean(row: number): boolean {
    const dataType = this.characteristics[row]?.dataType;
    return dataType === CharacteristicDataType.BOOLEAN;
  }

  public isNumeric(row) {
    const dataType = this.characteristics[row]?.dataType;
    return (
      dataType === CharacteristicDataType.FLOAT || dataType === CharacteristicDataType.ONE_FLOAT_PER_CHARACTERISTIC
    );
  }

  public isText(row) {
    const dataType = this.characteristics[row]?.dataType;
    return dataType === CharacteristicDataType.TEXT || dataType === CharacteristicDataType.ONE_TEXT_PER_PRODUCT;
  }

  public isInvalid(row: number, col: number) {
    const characteristic = this.characteristics[row];

    if (!this.isNumeric(row)) {
      return false;
    }

    const value = parseToNumber(characteristic?.measurements?.[col]?.value);
    if (!value) {
      return false;
    }

    const v1 = parseToNumber(characteristic.value1);
    const v2 = parseToNumber(characteristic.value2);

    if (v1 && v2) {
      return value < v1 || value > v2;
    } else if (v1) {
      return value < v1;
    } else if (v2) {
      return value > v2;
    }

    return false;
  }

  private isValueOkNok = (value: string) => {
    const isOk = value.trim().toLowerCase() === "ok";
    const isNok = value.trim().toLowerCase() === "nok";
    return isOk || isNok;
  };

  public format(value: any) {
    return valueOrEmpty(value);
  }
}
